module.exports = __webpack_public_path__ + "media/images/how_to_create_a_booking-0451685bdd19745277e7f51be464295d.png";